if($('.id--8').length){
    $('.id--8 #register-form>div.co-registration').first().find('fieldset').append('<div class="form-group js-validated-element-wrapper smart-label-wrapper"><label for="fileToUpload">'+priloha+'</label><input type="file" name="fileToUpload" id="fileToUpload"></div>')
    $(document).on('submit', '#register-form', function(e) { 
        var formEmail = $(this).find('#email').val()
        var fileInput = $(this).find('#fileToUpload')[0].files[0]
        if (!fileInput) {
            console.log("Soubor není vyplněný.");
            return;
        }
        var formdata = new FormData();      
        formdata.append("email", formEmail);
        formdata.append("file", fileInput);
        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };
        fetch("https://tools.shopcode.cz/e-mail_sender/rdo/www/", requestOptions)
        .then(response => response.json())
        .then(function(result){
           console.log(result.status)
          
        })
        .catch(function(){
           
        })
    })

}

